



















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import PaginationComponent from '@/shared/pagination.component.vue';
import DateFormat from '@/shared/utils/date-format';
import DaisyMessage from '@/domain/daisy-message/entity/daisy-message.entity';
import DaisyMessageService from '@/domain/daisy-message/service/daisy-message.service';
import DaisyMessageErrorHandler from '@/domain/daisy-message/service/daisy-message-error.handler';
import DaisyMessageFormModal from '../form/daisy-message-form-modal.component.vue';
import DaisyMessagePreviewModal from '../preview/daisy-message-preview-modal.component.vue';
import MessageTypes from '../daisy-message-types.json';
import Headers from './header.json';

@Component({
  components: {
    PaginationComponent,
    DaisyMessageFormModal,
    DaisyMessagePreviewModal,
  },
})
export default class DaisyMessageTableComponent extends Vue {
  @Prop() messages!: DaisyMessage[];

  @Prop() pagination!: any;

  @Prop({
    type: Boolean,
  }) loading!: boolean;

  @Prop({
    type: Boolean,
  }) hasUpdateDaisyMessage!: boolean;

  @Prop({
    type: Boolean,
  }) hasDeleteDaisyMessage!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  }) existingLanguages!: string[];

  headers = Headers;

  messageTypes = MessageTypes;

  openModal: boolean = false;

  openPreview: boolean = false;

  loadingDetailId: string = '';

  messageUpdated: DaisyMessage = new DaisyMessage();

  messagePreviewed: DaisyMessage = new DaisyMessage();

  messageTypeLabel(messageType: string): string {
    const type = this.messageTypes.find(it => it.value === messageType);
    return type ? type.text : messageType;
  }

  formatDateTime(date: string): string {
    return DateFormat.dateTimeFormated(date);
  }

  updateTable(page: any): void {
    this.$emit('update', page);
  }

  openUpdateModal(message: DaisyMessage): void {
    this.loadingDetailId = message.id;
    DaisyMessageService.getById(message.id)
      .then((detail) => {
        this.messageUpdated = detail;
        this.openModal = true;
      })
      .catch(DaisyMessageErrorHandler.handle)
      .finally(() => this.loadingDetailId = '');
  }

  closeModal(): void {
    this.openModal = false;
    this.updateTable(this.pagination);
  }

  openPreviewModal(message: DaisyMessage): void {
    this.messagePreviewed = message;
    this.openPreview = true;
  }

  closePreviewModal(): void {
    this.openPreview = false;
  }
}
